import React, { Component } from 'react';
import { Benefit } from '@eg/elements/Benefit';

import './FirstInformation.scss';

class FirstInformation extends Component {
  render() {
    return (
      <Benefit className="FirstInformation">
        Hier finden Sie eine <a href="https://www.ergo.de/de/Service/Anbieter" target="_blank" rel="noopener noreferrer">Erstinformation</a> zu Ihrem Vermittler.
      </Benefit>
    )
  }
}

export default FirstInformation;
